import * as firebase from "firebase";

// const config = {
//   apiKey: "AIzaSyCSk5gH-xlfNHhrM9op_fWmz57lQJaOrF0",
//   authDomain: "sampell-undercon-dev.firebaseapp.com",
//   databaseURL: "https://sampell-undercon-dev.firebaseio.com",
//   projectId: "sampell-undercon-dev",
//   storageBucket: "sampell-undercon-dev.appspot.com",
//   messagingSenderId: "83179972984"
// };

var config = {
  apiKey: "AIzaSyAfQPaAGVt7JY5RnpKXzLTMrGPIbolxl8w",
  authDomain: "sampell-client-prod.firebaseapp.com",
  databaseURL: "https://sampell-client-prod.firebaseio.com",
  projectId: "sampell-client-prod",
  storageBucket: "sampell-client-prod.appspot.com",
  messagingSenderId: "181757112396"
};

firebase.initializeApp(config);

export default firebase;
//
// export const database = firebase.database();

// database.ref().on('value', (snapshot) => {
//         const val = snapshot.val();
//         console.log(val);
//         });  //subscribe to the reference, and gives it back when it changes

// database.ref()
//     .once('value')
//     .then((snapshot) => {
//         const val = snapshot.val();
//         console.log(val);
//     })
//     .catch((e) => {
//        console.log('Error fetching data', e)
//     });

//database.ref('age').remove();

// database.ref().set({
//     name: 'Sonja',
//     age: 37,
//     job: 'Software Engineer',
//     location: {
//         city: 'berlin',
//         country: 'germany'
//     }
// }).then(() => {
//     console.log(('Data was saved'));
// }).catch((e) => {
//     console.log(('This failed', e));
// });

// database.ref().set('this is my data');
//
// database.ref('age').set(27);
// database.ref('location/city').set('Lichtenow');
//
// database.ref('attributes').set({
//     height: 174,
//     weight: 62
// });

// database.ref().update({
//     name: 'assi',
//     age: 40
// });

// database.ref().update({
//   job: "Manager",
//   "location/city": "Lichtenow"
// });



// WEBPACK FOOTER //
// ./src/firebase/firebase.js